import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Route बदले तो page को top पर ले जाए */
export default function ScrollToTop({ behavior = "auto" }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Browser की auto-restore बंद कर दो (वरना पहले वाली position रखता है)
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const run = () => {
      // अगर URL में #hash है तो उसी element तक स्क्रोल करो, वरना top पर
      if (hash) {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior });
          return;
        }
      }
      window.scrollTo({ top: 0, left: 0, behavior });
    };

    // layout पेंट होने के बाद स्क्रोल करें
    const id = requestAnimationFrame(run);
    return () => cancelAnimationFrame(id);
  }, [pathname, hash, behavior]);

  return null;
}
